import { makeStyles } from '@material-ui/core';

export const useWebsiteSummaryStyles = makeStyles(() => ({
    markdown: {
        '& h1, & h2, & h3': {
            marginTop: '1em',
            marginBottom: '0.5em',
        },
        '& ul': {
            paddingLeft: '1.5em',
        },
        '& p': {
            marginBottom: '0.5em',
        },
    },
}));
